import api from "./api";

export const getCategories = async () => {
    try {
        const response = await api.get(`/categories?populate=*`);
        // console.log(response.data.data);
        return (response.data.data);
    } catch (e) {
        console.error(e);
    }
};

export const getSingleCategory = async (id) => {
    try {
        const response = await api.get(`/categories/${id}?populate=*`);
        // console.log(response.data.data);
        return (response.data.data);
    } catch (e) {
        console.error(e);
    }
};

export const countCategories = async () => {
    try {
        const response = await getCategories();
        const length = response.length;
        // console.log(response.data.data);
        return length;
    } catch (e) {
        console.error(e);
    }
};

export const getFilteredCategories = async (filters = {}, page = 1, pageSize = 12) => {
    try {
        const queryParams = {
            populate: '*',
            filters: {},
            pagination: {
                page,
                pageSize
            }
        };

        // Add search term if provided
        if (filters.search) {
            queryParams.filters.$or = [
                {
                    name: {
                        $containsi: filters.search
                    }
                },
                {
                    description: {
                        $containsi: filters.search
                    }
                }
            ];
        }

        // Add sorting if provided
        if (filters.sort) {
            queryParams.sort = [filters.sort];
        }

        const response = await api.get('/categories', { params: queryParams });
        return {
            data: response.data.data,
            pagination: response.data.meta.pagination
        };
    } catch (e) {
        console.error(e);
        return {
            data: [],
            pagination: {
                page: 1,
                pageSize: pageSize,
                pageCount: 0,
                total: 0
            }
        };
    }
};

export const deleteCategory = async (id) => {
    try {
        const response = await api.delete(`/categories/${id}`);
        // console.log(response);
        return true;
    } catch (err) {
        console.error('Error deleting category:', err);
        return false
    }
};